export const ORDERS_QUERY_VARIABLES = {
  input: {
    page: 1,
    take: 10,
  },
};

export const ORDERS_V2_QUERY_VARIABLES = {
  input: {
    page: 1,
    take: 10,
    includePlacedOrders: true,
  },
};
